'use strict';

const $ = (window.jQuery = window.$ = require('jquery'));

module.exports = function() {
    const $root = $('.new-megamenu');

    if (!$root.length) {
        return;
    }

    const isDesktop = function(element) {
        return $(element).closest('.main-menu').css('position') !== 'fixed';
    };
    const $mainMenu = $root.closest('.main-menu');
    $('.navbar-toggler').off('click').on('click', function(event) {
        event.preventDefault();
        const $toggler = $(this);
        const $searchPanel = $('header .search-mobile .site-search.show');

        if ($searchPanel.length) {
            $searchPanel.find('.site-search-close').trigger('click');
            return;
        }

        const shouldOpen = !$mainMenu.hasClass('in');
        $toggler.toggleClass('opened', shouldOpen);
        $mainMenu.toggleClass('in', shouldOpen).toggleClass('d-none', !shouldOpen);
        $('body').toggleClass('menu-open', shouldOpen);

        if (shouldOpen) {
            $mainMenu.attr('aria-hidden', 'false');
            $root.find('.navbar-nav .nav-link').first().trigger('focus');
        } else {
            $mainMenu.attr('aria-hidden', 'true');
            $root.find('.new-megamenu-section.show').each(function() {
                $(this).removeClass('show');
                $(this).children('.new-megamenu-flyout').removeClass('show').attr('aria-hidden', 'true');
                $(this).children('.dropdown-toggle').attr('aria-expanded', 'false');
                $(this).find('.new-megamenu-current-item').remove();
            });
        }
    });

    const $toggles = $root.find('.new-megamenu-toggle');

    const getSection = function(toggle) {
        const $section = $(toggle).closest('.new-megamenu-section');
        return $section.length ? $section : $(toggle).parent();
    };

    const getPanel = function(toggle) {
        return $(toggle).next('.new-megamenu-flyout');
    };

    $toggles.off('click mouseenter');
    $toggles.parent().off('mouseleave');

    $toggles.on('click', function(event) {
        if (isDesktop(this)) {
            return;
        }

        const $toggle = $(this);
        const $section = getSection(this);
        const $panel = getPanel(this);
        const $oldCurrent = $panel.children('.new-megamenu-current-item');
        const current = $('<div class="new-megamenu-current-item" role="heading"></div>');

        $oldCurrent.remove();
        current.text($toggle.text());
        $panel.prepend(current).attr('aria-hidden', 'false');
        $section.addClass('show');
        $toggle.attr('aria-expanded', 'true');
        event.preventDefault();
    });

    $toggles.on('mouseenter', function() {
        if (!isDesktop(this)) {
            return;
        }

        const $section = getSection(this);
        const $panel = getPanel(this);
        $root.find('.new-megamenu-flyout.show').not($panel).each(function() {
            $(this).removeClass('show').attr('aria-hidden', 'true');
            $(this).prev('.new-megamenu-toggle').attr('aria-expanded', 'false');
            $(this).closest('.new-megamenu-section').removeClass('show');
        });

        $section.addClass('show');
        $panel.addClass('show').attr('aria-hidden', 'false');
        $(this).attr('aria-expanded', 'true');
    });

    $toggles.parent().on('mouseleave', function() {
        if (!isDesktop(this)) {
            return;
        }

        $(this).removeClass('show');
        $(this).find('.new-megamenu-flyout').removeClass('show').attr('aria-hidden', 'true');
        $(this).find('.new-megamenu-toggle').attr('aria-expanded', 'false');
    });

    $root.on('click', '.new-megamenu-back', function(event) {
        event.preventDefault();
        const $section = $(this).closest('.new-megamenu-section');
        $section.removeClass('show');
        $section.children('.new-megamenu-flyout').removeClass('show').attr('aria-hidden', 'true');
        $section.children('.dropdown-toggle').attr('aria-expanded', 'false').focus();
        $section.find('.new-megamenu-current-item').remove();
    });
};
